module.exports = __webpack_public_path__ + "img/Group 97721.4c567131.png";